<template>
  <div class="personal-center">
    <!-- 证书打印组件 -->
    <div v-if="showCertificate" class="certificate-modal">
      <div class="certificate-modal-content">
        <div class="certificate-header">
          <h3>证书预览</h3>
          <el-button @click="closeCertificate" icon="el-icon-close" circle></el-button>
        </div>
        <div class="certificate-body">
          <Certificate
            ref="certificate"
            :student-name="certificateData?.userName || '张三'"
            :gender="certificateData?.sex || '男'"
            :id-number="certificateData?.idCard || '123456789012345678'"
            :certificate-number="certificateData?.certificateNo || 'CAMH2024001'"
            :completion-date="certificateData?.dateTime || ''"
            :issue-date="certificateData?.dateTime || ''"
          />
        </div>
        <div class="certificate-actions">
          <el-button @click="closeCertificate">取消</el-button>
          <!-- <el-button type="primary" @click="printCertificate" icon="el-icon-printer">打印证书</el-button> -->
        </div>
      </div>
    </div>
    <div class="page-header">
      <div class="header-content">
        <div class="header-left">
          <div class="avatar-section">
            <!-- <div class="user-avatar">
              <i class="el-icon-user-solid"></i>
            </div> -->
            <div class="user-info">
              <h1 class="user-name">{{ (userInfo && userInfo.name) || '未登录' }}</h1>
              <!-- <p class="user-title">心理咨询师学员</p> -->
            </div>
          </div>
        </div>
        <div class="header-right">
          <div class="stats-cards">
            <div class="stat-card">
              <div class="stat-number">{{ orders.filter(o => o.status === 'pending').length }}</div>
              <div class="stat-label1">待缴费</div>
            </div>
            <!-- <div class="stat-card">
              <div class="stat-number">{{ orders.filter(o => o.status === 'completed').length }}</div>
              <div class="stat-label">已完成课程</div>
            </div> -->
            <div class="stat-card">
              <div class="stat-number">{{ orders.filter(o => o.status === 'paid').length }}</div>
              <div class="stat-label1">已缴费</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="order-section">
      <div class="section-header">
        <div class="section-title">
          <i class="el-icon-s-order"></i>
          <h2>我的订单</h2>
        </div>
        <div class="order-tabs">
          <el-tabs v-model="activeOrderTab" @tab-click="handleOrderTabClick" type="card">
            <el-tab-pane name="all">
              <span slot="label">
                <i class="el-icon-document"></i>
                全部订单
              </span>
            </el-tab-pane>
            <el-tab-pane name="pending">
              <span slot="label">
                <i class="el-icon-time"></i>
                待缴费
              </span>
            </el-tab-pane>
            <!-- <el-tab-pane name="learning">
              <span slot="label">
                <i class="el-icon-video-play"></i>
                学习中
              </span>
            </el-tab-pane> -->
            <el-tab-pane name="paid">
              <span slot="label">
                <i class="el-icon-wallet"></i>
                已缴费
              </span>
            </el-tab-pane>
            <!-- <el-tab-pane name="completed">
              <span slot="label">
                <i class="el-icon-circle-check"></i>
                已完成
              </span>
            </el-tab-pane> -->
          </el-tabs>
        </div>
      </div>
      
      <div class="order-list">
        <!-- 加载状态 -->
        <div v-if="ordersLoading" class="loading-state">
          <i class="el-icon-loading"></i>
          <p>正在加载订单数据...</p>
        </div>
        
        <!-- 订单列表 -->
        <template v-else-if="filteredOrders.length > 0">
          <div 
            v-for="order in filteredOrders" 
            :key="order.id" 
            class="order-card"
          >
            <div class="order-header">
              <div class="order-info">
                <div class="order-number">
                  <i class="el-icon-document"></i>
                  <span>订单号：{{ order.orderNumber }}</span>
                </div>
                <div class="order-date">
                  <i class="el-icon-time"></i>
                  <span>创建时间：{{ order.createTime }}</span>
                </div>
              </div>
              <div class="order-status">
                <el-tag 
                  :type="getOrderStatusType(order.status)" 
                  effect="dark"
                  size="medium"
                >
                  <i :class="getOrderStatusIcon(order.status)"></i>
                  {{ order.statusText }}
                </el-tag>
              </div>
            </div>
            
            <div class="order-content">
              <div class="course-info">
                <!-- <div class="course-image-wrapper">
                  <img :src="order.courseImage" class="course-image" />
                  <div class="course-overlay">
                    <i class="el-icon-video-play"></i>
                  </div>
                </div> -->
                <div class="course-details">
                  <h3 class="course-name">{{ order.courseName }}</h3>
                  <!-- <div class="course-meta">
                    <div class="meta-item">
                      <i class="el-icon-time"></i>
                      <span>{{ order.courseDuration }}</span>
                    </div>
                  </div> -->
                </div>
              </div>
              <div class="order-price">
                <div class="price-label">订单金额</div>
                <div class="price">￥{{ order.price.toLocaleString() }}</div>
              </div>
            </div>
            
            <div class="order-actions">
              <el-button
                v-if="order.status === 'pending'"
                type="primary"
                size="medium"
                icon="el-icon-wallet"
                @click="payOrder(order)"
                class="action-btn primary-btn"
              >
                立即缴费
              </el-button>
            </div>
          </div>
        </template>

        <!-- 空状态 -->
        <div v-else class="empty-state">
          <i class="el-icon-document"></i>
          <p>暂无相关订单</p>
        </div>
      </div>
    </div>

    <div class="course-section">
      <div class="section-header">
        <div class="section-title">
          <i class="el-icon-reading"></i>
          <h2>我的课程</h2>
        </div>
      </div>

      <div class="course-list">
        <!-- 加载课程数据的加载状态 -->
        <div v-if="coursesLoading" class="loading-state">
          <i class="el-icon-loading"></i>
          <p>正在加载课程数据...</p>
        </div>

        <template v-else-if="myCourses.length > 0">
          <div
            v-for="course in myCourses"
            :key="course.id"
            class="order-card"
          >
            <div class="order-header">
              <div class="order-info">
                <div class="order-number">
                  <i class="el-icon-notebook-2"></i>
                  <span>{{ course.courseName }}</span>
                </div>
                <div class="order-date">
                  <i class="el-icon-time"></i>
                  <span>{{ course.createTime }}</span>
                </div>
              </div>
              <div class="order-status">
                <el-tag :type="getOrderStatusType(course.status)" effect="dark" size="medium">
                  <i :class="getOrderStatusIcon(course.status)"></i>
                  {{ course.statusText }}
                </el-tag>
              </div>
            </div>

            <div class="order-content">
              <div class="course-info">
                <div class="course-details">
                  <h3 class="course-name">{{ course.courseName }}</h3>
                </div>
              </div>
              <div class="course-stats">
                <div class="stat-line">
                  <span class="stat-label">已考次数</span>
                  <span class="stat-value">{{ (course.attemptsCount || 0) + ' 次' }}</span>
                </div>
                <div class="stat-line">
                  <span class="stat-label">分数</span>
                  <span class="stat-value">{{ course.finalScore != null ? (course.finalScore + ' 分') : '-' }}</span>
                </div>
              </div>
            </div>

            <div class="order-actions">
              <el-button
                v-if="course.status === 'completed'"
                type="success"
                size="medium"
                icon="el-icon-trophy"
                @click="viewCertificate(course)"
                class="action-btn success-btn"
              >
                打印证书
              </el-button>

              <!-- <el-button
                v-if="course.status === 'completed'"
                type="success"
                size="medium"
                icon="el-icon-trophy"
                @click="showPrintNotice"
                class="action-btn success-btn"
              >
                打印证书
              </el-button> -->

              <el-button
                v-else-if="course.status === 'learning'"
                type="primary"
                size="medium"
                icon="el-icon-video-play"
                @click="continueStudy(course)"
                class="action-btn primary-btn"
              >
                继续学习
              </el-button>

              <el-button
                v-else-if="course.status === 'failed'"
                type="info"
                size="medium"
                icon="el-icon-warning"
                disabled
                class="action-btn info-btn"
              >
                未通过
              </el-button>
            </div>
          </div>
        </template>

        <div v-else class="empty-state">
          <i class="el-icon-reading"></i>
          <p>暂无课程</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '../common/auth.js'
import Certificate from './Certificate.vue'
import Vue from 'vue'
import Print from 'vue-print-nb'

Vue.use(Print)

export default {
  name: 'PersonalCenter',
  components: {
    Certificate
  },
  data() {
    return {
      activeOrderTab: 'all',
      userInfo: null,
      orders: [],
      ordersLoading: false,
      courses: [],
      coursesLoading: false,
      showCertificate: false,
      currentCertificate: null,
      certificateData: null,
      printOptions: {
        id: 'certificate',
        popTitle: '心理咨询师培训证书'
      }
    }
  },
  async mounted() {
    await this.loadUserInfo()
    await this.loadOrders()
  },
  computed: {
    // 根据当前标签页过滤订单
    filteredOrders() {
      if (this.activeOrderTab === 'all') {
        return this.orders
      }
      return this.orders.filter(order => order.status === this.activeOrderTab)
    },
    // 我的课程：从订单中提取已缴费/学习中/已完成的课程
    myCourses() {
      return this.courses
    }
  },
  methods: {
    async loadUserInfo() {
      try {
        const result = await authService.getUserInfo()
        if (result.success) {
          this.userInfo = result.data
        }
      } catch (e) {
        // ignore
      }
    },

    // 加载订单数据
    async loadOrders() {
      this.ordersLoading = true
      try {
        const response = await this.$http.get('/api.php/v1.order/lists')
        if (response.data && response.data.code === 0) {
          const orderData = response.data.data.data
          // 转换订单数据格式
          this.orders = orderData.map(order => this.transformOrderData(order))
        } else {
          console.error('获取订单列表失败:', response.data?.msg || '未知错误')
          this.orders = []
        }
      } catch (error) {
        console.error('获取订单列表失败:', error)
        this.orders = []
      } finally {
        this.ordersLoading = false
        // 订单加载完成后，加载课程数据
        if (this.orders.length > 0) {
          this.loadCourses()
        }
      }
    },

    // 加载课程数据
    async loadCourses() {
      this.coursesLoading = true
      try {
        console.log('所有订单数据:', this.orders)
        // 筛选已缴费、学习中、已完成的订单（使用转换后的状态字符串）
        const validOrders = this.orders.filter(order => 
          order.status === 'paid' || 
          order.status === 'learning' || 
          order.status === 'completed'
        )
        console.log('符合条件的订单:', validOrders)
        
        if (validOrders.length === 0) {
          this.courses = []
          return
        }

        // 并发请求所有课程的成绩数据
        const coursePromises = validOrders.map(async (order) => {
          try {
            const response = await this.$http.get(`/api.php/v1.course/score?cid=${order.cid}`)
            if (response.data && response.data.code === 0) {
              const scoreData = response.data.data.res
              const courseName = this.getCourseNameByCid(order.cid)
              
              // 判断课程状态
              let status, statusText
              if (scoreData.score >= 80) {
                status = 'completed'
                statusText = '已完成'
              } else if (scoreData.count >= 3) {
                status = 'failed'
                statusText = '未通过'
              } else {
                status = 'learning'
                statusText = '学习中'
              }

              return {
                id: order.id,
                cid: order.cid,
                orderNumber: order.orderNumber,
                courseName: courseName,
                courseImage: this.getCourseImage(order.cid),
                courseDuration: '课程时长',
                price: order.price,
                attemptsCount: scoreData.count,
                finalScore: scoreData.score,
                status: status,
                statusText: statusText,
                createTime: order.payTime || order.createTime,
                progress: status === 'completed' ? 100 : 50
              }
            } else {
              console.error(`获取课程${order.cid}成绩失败:`, response.data?.msg || '未知错误')
              return null
            }
          } catch (error) {
            console.error(`获取课程${order.cid}成绩失败:`, error)
            return null
          }
        })

        const courseResults = await Promise.all(coursePromises)
        this.courses = courseResults.filter(course => course !== null)
      } catch (error) {
        console.error('加载课程数据失败:', error)
        this.courses = []
      } finally {
        this.coursesLoading = false
      }
    },

    // 根据cid获取课程名称
    getCourseNameByCid(cid) {
      const courseNames = {
        1: '初级咨询师课程',
        2: '中级咨询师课程',
        3: '高级咨询师课程',
        4: '督导师课程'
      }
      return courseNames[cid] || '未知课程'
    },

    // 转换订单数据格式
    transformOrderData(order) {
      // 根据status字段判断订单状态
      let status, statusText
      if (order.status === 0) {
        status = 'unregistered'
        statusText = '未报名'
      } else if (order.status === 1) {
        status = 'pending'
        statusText = '待缴费'
      } else if (order.status === 2) {
        status = 'paid'
        statusText = '已缴费'
      } else if (order.status === 3) {
        status = 'learning'
        statusText = '学习中'
      } else if (order.status === 4) {
        status = 'completed'
        statusText = '已完成'
      } else {
        status = 'unknown'
        statusText = '未知状态'
      }

      // 根据cid获取课程名称
      const courseNames = {
        1: '初级咨询师',
        2: '中级咨询师', 
        3: '高级咨询师',
        4: '督导师'
      }

      return {
        id: order.id,
        cid: order.cid,
        orderNumber: order.orderNum || `ORDER${order.id}`,
        courseName: courseNames[order.cid] || '未知课程',
        courseImage: this.getCourseImage(order.cid),
        courseDuration: '课程时长',
        price: order.amount ? order.amount / 100 : 0, // amount是分，转换为元
        status: status,
        statusText: statusText,
        createTime: this.formatTime(order.createTime),
        progress: 0
      }
    },

    // 获取课程图片
    getCourseImage(cid) {
      const courseImages = {
        1: 'https://via.placeholder.com/120x80/2a91ff/ffffff?text=初级',
        2: 'https://via.placeholder.com/120x80/667eea/ffffff?text=中级',
        3: 'https://via.placeholder.com/120x80/faad14/ffffff?text=高级',
        4: 'https://via.placeholder.com/120x80/52c41a/ffffff?text=督导师'
      }
      return courseImages[cid] || 'https://via.placeholder.com/120x80/999999/ffffff?text=课程'
    },

    // 格式化时间
    formatTime(timestamp) {
      if (!timestamp) return '未知时间'
      if (typeof timestamp === 'string') return timestamp
      
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    // 订单标签页切换
    handleOrderTabClick(tab) {
      this.activeOrderTab = tab.name
    },
    
    // 获取订单状态对应的标签类型
    getOrderStatusType(status) {
      const statusMap = {
        'unregistered': 'info',
        'pending': 'warning',
        'paid': 'primary',
        'learning': 'primary', 
        'completed': 'success',
        'failed': 'danger',
        'unknown': 'info'
      }
      return statusMap[status] || 'info'
    },
    
    // 获取订单状态对应的图标
    getOrderStatusIcon(status) {
      const iconMap = {
        'unregistered': 'el-icon-edit',
        'pending': 'el-icon-time',
        'paid': 'el-icon-wallet',
        'learning': 'el-icon-video-play',
        'completed': 'el-icon-circle-check',
        'failed': 'el-icon-warning',
        'unknown': 'el-icon-info'
      }
      return iconMap[status] || 'el-icon-info'
    },
    
    // 支付订单
    payOrder(order) {
      this.$emit('pay-order', order)
    },
    
    // 继续学习
    continueStudy(order) {
      this.$emit('continue-study', order)
    },
    
    // 打印证书提醒
    showPrintNotice() {
      this.$alert('证书打印功能维护中，请稍后再试。', '提示', {
        confirmButtonText: '好的'
      })
    },

    // 打印证书
    async viewCertificate(order) {
      this.currentCertificate = order
      try {
        // 获取证书数据
        const response = await this.$http.get(`/api.php/v1.course/certificate?cid=${order.cid}`)
        if (response.data && response.data.code === 0) {
          this.certificateData = response.data.data.res
          this.showCertificate = true
        } else {
          this.$message.error('获取证书数据失败: ' + (response.data?.msg || '未知错误'))
        }
      } catch (error) {
        console.error('获取证书数据失败:', error)
        this.$message.error('获取证书数据失败')
      }
    },
    
    // 关闭证书预览
    closeCertificate() {
      this.showCertificate = false
      this.currentCertificate = null
      this.certificateData = null
    },
    
    // 打印证书
    printCertificate() {
      // 获取证书元素
      const certificateElement = this.$refs.certificate.$el
      if (!certificateElement) return
      
      // 创建新窗口进行打印
      const printWindow = window.open('', '_blank', 'width=800,height=600')
      
      // 获取背景图片URL
      const backgroundImageUrl = this.$refs.certificate.backgroundImageUrl
      
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>心理咨询师培训证书</title>
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            body {
              font-family: Arial, sans-serif;
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            .certificate-container {
              width: 800px;
              height: 600px;
              margin: 0 auto;
              background-image: url('${backgroundImageUrl}');
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
              position: relative;
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            .certificate-content {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              display: flex;
              padding: 40px;
            }
            .left-content {
              position: absolute;
              top: 50%;
              left: 15%;
              transform: translateY(-50%);
              width: 35%;
            }
            .right-content {
              position: absolute;
              top: 35%;
              right: -2.5%;
              transform: translateY(-50%);
              width: 35%;
            }
            .student-name-left {
              position: absolute;
              top: 46.5px;
              left: -50px;
              font-size: 18px;
              font-weight: bold;
              color: #333;
            }
            .completion-year, .completion-month, .completion-day {
              position: absolute;
              top: 58px;
              font-size: 16px;
              font-weight: 600;
              color: #333;
            }
            .completion-year { left: 140px; }
            .completion-month { left: 202px; }
            .completion-day { left: 246px; }
            .student-name-right {
              position: absolute;
              top: -55px;
              left: 0;
              font-size: 16px;
              color: #333;
            }
            .gender {
              position: absolute;
              top: 8px;
              left: 0;
              font-size: 16px;
              color: #333;
            }
            .id-number {
              position: absolute;
              top: 75px;
              left: 0;
              font-size: 16px;
              color: #333;
            }
            .certificate-number {
              position: absolute;
              top: 140px;
              left: 0;
              font-size: 16px;
              color: #333;
            }
            .issue-date-formatted {
              position: absolute;
              top: 200px;
              left: 0;
              font-size: 16px;
              color: #333;
            }
            @media print {
              @page {
                margin: 0;
                size: A4;
              }
              body {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }
              .certificate-container {
                background-image: url('${backgroundImageUrl}') !important;
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }
            }
          </style>
        </head>
        <body>
          ${certificateElement.outerHTML}
        </body>
        </html>
      `)
      
      printWindow.document.close()
      
      // 等待图片加载完成后打印
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.focus()
          printWindow.print()
          printWindow.close()
        }, 500)
      }
    },
    
    
    // 查看订单详情
    viewOrderDetail(order) {
      this.$emit('view-order-detail', order)
    },

    // 立即报名
    registerCourse(order) {
      this.$emit('register-course', order)
    },

    // 设置激活的订单标签页
    setActiveOrderTab(tabName) {
      this.activeOrderTab = tabName
    }
  }
}
</script>

<style scoped>
.personal-center {
  height: auto;
  overflow: visible;
}

.page-header {
  background: linear-gradient(135deg, #2a91ff 0%, #667eea 100%);
  border-radius: 16px;
  padding: 25px;
  color: white;
  margin-bottom: 25px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  flex: 1;
}

.avatar-section {
  display: flex;
  align-items: center;
  gap: 20px;
}

.user-avatar {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: white;
  backdrop-filter: blur(10px);
}

.user-info {
  flex: 1;
}

.user-name {
  font-size: 2em;
  font-weight: bold;
  margin: 0 0 8px 0;
  color: white;
}

.header-right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.stats-cards {
  display: flex;
  gap: 20px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  min-width: 120px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.stat-number {
  font-size: 2.2em;
  font-weight: bold;
  color: white;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 2.2em;
  font-weight: bold;
  color: white;
}

.order-section {
  background: white;
  border-radius: 16px;
  padding: 25px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  margin-bottom: 25px;
}

.course-section {
  background: white;
  border-radius: 16px;
  padding: 25px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.section-header {
  margin-bottom: 20px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.section-title i {
  font-size: 24px;
  color: #2a91ff;
}

.section-title h2 {
  font-size: 1.6em;
  color: #333;
  margin: 0;
  font-weight: 600;
}

.order-tabs {
  border-bottom: 1px solid #e9ecef;
}

.order-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.order-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.order-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #2a91ff, #667eea);
}

.order-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(42, 145, 255, 0.15);
  border-color: #2a91ff;
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f5f5f5;
}

.order-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.order-number {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #333;
  font-size: 16px;
}

.order-number i {
  color: #2a91ff;
  font-size: 16px;
}

.order-date {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #666;
  font-size: 14px;
}

.order-date i {
  color: #999;
  font-size: 14px;
}

.order-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.course-info {
  display: flex;
  align-items: flex-start;
  flex: 1;
  gap: 20px;
}

.course-image-wrapper {
  position: relative;
  flex-shrink: 0;
}

.course-image {
  width: 120px;
  height: 80px;
  object-fit: cover;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.course-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(42, 145, 255, 0.8);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
}

.course-overlay i {
  font-size: 24px;
  color: white;
}

.course-image-wrapper:hover .course-overlay {
  opacity: 1;
}

.course-image-wrapper:hover .course-image {
  transform: scale(1.05);
}

.course-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.course-name {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
  line-height: 1.3;
}

.course-meta {
  display: flex;
  gap: 24px;
  margin-top: 8px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #666;
}

.meta-item i {
  color: #2a91ff;
  font-size: 14px;
}

.progress-section {
  margin-top: 12px;
}

.progress-text {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.order-price {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  min-width: 120px;
}

.course-stats {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  min-width: 160px;
}

.stat-line {
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 2px 0;
}

.stat-label {
  font-size: 12px;
  color: #999;
}

.stat-label1 {
  font-size: 15px;
  font-weight: bold;
  color: white;
}

.stat-value {
  font-size: 16px;
  font-weight: 600;
  color: #2a91ff;
}

.price-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
}

.price {
  font-size: 28px;
  font-weight: bold;
  color: #2a91ff;
  line-height: 1;
}

.order-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #f5f5f5;
  margin-top: 16px;
}

.action-btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  padding: 10px 20px;
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.primary-btn {
  background: linear-gradient(135deg, #2a91ff, #667eea);
}

.success-btn {
  background: linear-gradient(135deg, #52c41a, #73d13d);
}

.warning-btn {
  background: linear-gradient(135deg, #faad14, #ffc53d);
}

.info-btn {
  background: #f5f5f5;
  color: #666;
}

.info-btn:hover {
  background: #e6f7ff;
  color: #2a91ff;
}

.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #999;
  background: #fafafa;
  border-radius: 12px;
  margin: 20px 0;
}

.empty-state i {
  font-size: 80px;
  color: #d9d9d9;
  margin-bottom: 24px;
  display: block;
}

.empty-state p {
  font-size: 18px;
  margin: 0;
  color: #666;
}

.loading-state {
  text-align: center;
  padding: 80px 20px;
  color: #999;
  background: #fafafa;
  border-radius: 12px;
  margin: 20px 0;
}

.loading-state i {
  font-size: 48px;
  color: #2a91ff;
  margin-bottom: 20px;
  display: block;
  animation: rotate 1s linear infinite;
}

.loading-state p {
  font-size: 16px;
  margin: 0;
  color: #666;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 证书模态框样式 */
.certificate-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.certificate-modal-content {
  background: white;
  border-radius: 12px;
  max-width: 1000px;
  max-height: 90vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.certificate-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
  border-radius: 12px 12px 0 0;
}

.certificate-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
  font-weight: 600;
}

.certificate-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background: #fafafa;
}

.certificate-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #e9ecef;
  background: white;
  border-radius: 0 0 12px 12px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .certificate-modal {
    padding: 10px;
  }
  
  .certificate-modal-content {
    max-height: 95vh;
  }
  
  .certificate-body {
    padding: 15px;
  }
  
  .certificate-actions {
    flex-direction: column;
    gap: 10px;
  }
  
  .certificate-actions .el-button {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 20px;
  }

  .stats-cards {
    justify-content: center;
  }

  .order-content {
    flex-direction: column;
    gap: 15px;
  }

  .course-info {
    width: 100%;
  }

  .order-price {
    align-items: center;
  }

  .order-actions {
    justify-content: center;
  }
}
</style>
